interface IProps {
  source: string | null;
  isPlatform?: boolean; // RAG-50 : produit importé de la Plateforme Socoda
}

/**
 * Badge telling whether a record (category or product) comes from the Socoda PIM
 * (default), the Interactiv PIM, or — for products — the Socoda platform catalogue.
 */
export default function SourceBadge({ source, isPlatform = false }: IProps) {
  const isInteractiv = source === "interactiv";

  const label = isPlatform ? "Plateforme" : isInteractiv ? "Interactiv" : "Socoda";
  const classes = isPlatform
    ? "bg-emerald-100 text-emerald-700"
    : isInteractiv
    ? "bg-violet-100 text-violet-700"
    : "bg-sky-100 text-sky-700";

  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${classes}`}
    >
      {label}
    </span>
  );
}
